import React from 'react';
import KeyboardArrowLeftIcon from 'mdi-react/KeyboardArrowLeftIcon';
import { mediaQuery } from '../util/ui';
import Link from 'next/link';

export interface BackLinkProps {
  text: string;
  href: string;
}

export class BackLink extends React.PureComponent<BackLinkProps> {
  constructor(props: BackLinkProps) {
    super(props);
  }

  public render() {
    const { text, href } = this.props;
    return (
      <Link href={href}>
        <a>
          <KeyboardArrowLeftIcon />
          <span>{text}</span>
          <style jsx>{`
            a {
              display: inline-flex;
              align-items: center;
              text-decoration: none;
            }

            a,
            a:visited {
              color: #424242;
            }

            span {
              font-family: var(--font-family-primary);
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: normal;
              line-height: 1.5;
              margin-left: 10px;
            }

            @media ${mediaQuery.ExtraLarge} {
              span {
                font-size: 18px;
              }
            }
          `}</style>
        </a>
      </Link>
    );
  }
}
